<template>
  <div class="scrollwrap" ref="scrollV" :key="comkey">
    <slot name="defaultScroll" v-if="leftarr && leftarr.length || noAsync"></slot>
    <slot name="scrolllist"></slot>
    <empty :content="noData" v-if="leftarr && leftarr.length === 0 && !noAsync"></empty>
    <div class="loadarea" v-show="loadvisible">
      <span>{{loadInfo}}</span>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import Bscroll from 'better-scroll'
import empty from '../other/empty'
export default {
  name: 'scrollview',
  data () {
    return {
      loadInfo: this.loadmes,
      loadvisible: !1,
      noData: '暂无数据!'
    }
  },
  props: {
    comkey: {
      type: String,
      default: ''
    },
    probeType: {
      type: Number,
      default: 1
    },
    loadMore: {
      type: Boolean,
      default: !1
    },
    click: {
      type: Boolean,
      default: !0
    },
    pullup: {
      type: Boolean,
      default: !0
    },
    noAsync: {
      type: Boolean,
      default: !0
    },
    leftarr: {
      type: Array,
      default: () => []
    },
    rightarr: {
      type: Array,
      default: () => []
    },
    bounce: {
      type: Boolean,
      default: !0
    },
    loadmes: {
      type: String,
      default: '---- 上拉加载更多 ----'
    },
    loadingmes: {
      type: String,
      default: '---- 加载数据中 ----'
    },
    loadfinish: {
      type: String,
      default: '---- 加载完成！----'
    },
    loadend: {
      type: String,
      default: '---- 没有更多内容 ----'
    },
    loadstatus: {
      type: Number,
      default: 0
    },
    scrollX: {
      type: Boolean,
      default: !1
    },
    scrollY: {
      type: Boolean,
      default: !0
    },
    scrollEvent: {
      type: Function
    },
    stopPropagation: {
      type: Boolean,
      default: !1
    },
    momentum: {
      type: Boolean,
      default: !0
    },
    preventDefault: {
      type: Boolean,
      default: !0
    },
    listenScroll: {
      type: Boolean,
      default: false
    },
    showScrollbar: {
      type: Boolean,
      default: false
    },
    maxScrollY: { // 触发刷新的距离
      type: Number,
      default: 20
    },
    bounceConfig: { // bounce详细配置
      type: Object,
      default: undefined
    },
    useTransition: { // bounce详细配置
      type: Boolean,
      default: true
    }
  },
  mounted() {
    // this._initComponent()
  },
  methods: {
    _initComponent () {
      this.scroll = new Bscroll(this.$refs.scrollV, {
        click: this.click,
        stopPropagation: this.stopPropagation,
        preventDefault: this.preventDefault,
        bounce: this.bounceConfig ? this.bounceConfig : this.bounce,
        probeType: this.probeType,
        autoBlur: true,
        scrollX: this.scrollX,
        momentum: this.momentum,
        scrollbar: this.showScrollbar ? { //滚动条
          fade: true,
          interactive: false // 1.8.0 新增
        } : false,
        // preventDefaultException: {className:/(^|\s)teamUpScroll(\s|$)/},
        mouseWheel: true,
        useTransition: false,
      })
      if (this.pullup) {
        this.scroll.on('touchEnd', () => {
          this.scroll.y <= this.scroll.maxScrollY - this.maxScrollY ? this.$emit('scrollEndHandle') : (this.loadvisible = !1);
          if (this.scroll.y > this.scroll.maxScrollY - this.maxScrollY) {
            this.$emit('scrollEndHandle', 'cancel'); // 取消加载
          }
          let activeElement = document.activeElement;
          if (activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA')) {
            activeElement.blur()
          }
        });
        this.loadMore &&
          this.scroll.on('scroll', (pos) => {
            if (pos.y < this.scroll.maxScrollY && pos.y > this.scroll.maxScrollY - this.maxScrollY) {
              this.$emit('scrollHandle', 'willLoadMore')
            } else if (pos.y < this.scroll.maxScrollY) {
              this.$emit('scrollHandle', 'startLoadMore')
            }
            pos.y < this.scroll.maxScrollY - this.maxScrollY && (this.loadvisible = !0)
          })
      }
      if (this.listenScroll) {
        this.scroll.on('scroll', (pos) => {
          this.$emit('scroll', pos)
        })
      }
      this.scroll.on('beforeScrollStart', ()=>{
        this.scroll.refresh();
      });
    },
    hideLayer () {
      setTimeout(() => {
        this.loadvisible = !1
      }, 500)
    },
    refresh () {
      this.scroll.refresh()
    },
    scrollToTop () {
      this.scroll.scrollTo(0, 0, 0)
      this.scroll.refresh()
    },
    disable () {
      this.scroll.disable();
    },
    enable () {
      this.scroll.enable();
    },
    bindScroll () {
      this.scroll.on('scroll', () => {
        this.scrollEvent()
      })
    },
    scrollTo (x, y = 0) {
      this.scroll && this.scroll.scrollTo(x, y)
    },
    scrollToElement (id) {
      this.scroll.scrollToElement('#' + id, 500);
    }
  },
  watch: {
    loadstatus () {
      switch (this.loadstatus) {
        case 0:
          this.loadInfo = this.loadmes  // 上拉加载更多
          break
        case 1: // 加载完成
          this.loadInfo = this.loadfinish
          this.hideLayer()
          break
        case -1:
          this.loadInfo = this.loadingmes  // 加载数据中
          break
        case 2: // 没有更多内容
          this.loadInfo = this.loadend
          this.hideLayer()
          break
      }
      /* eslint-disable no-unused-expressions */
      // this.loadstatus === 0 && (this.loadInfo = this.loadmes)
      // this.loadstatus === 1 && (this.loadInfo = this.loadfinish, this.hideLayer())
      // this.loadstatus === -1 && (this.loadInfo = this.loadingmes)
      // this.loadstatus === 2 && (this.loadInfo = this.loadend, this.hideLayer())
    }
  },
  components: {
    empty
  }
}
</script>
<style rel="stylesheet/stylus" lang="stylus">
  @import "../../assets/css/mixin.styl";
  .scrollwrap
    position absolute
    width 100%
    top 0
    left 0
    bottom 0
    overflow hidden
    .loadarea
      position absolute
      bottom 0
      left 0
      width 100%
      height rpx(60)
      line-height rpx(60)
      color #fff
      font-size rpx(26)
      background-color rgba(0,0,0, 0.4)
      text-align center
</style>



// WEBPACK FOOTER //
// src/starcharge/components/scroll/list.vue